import { MiniGraphsSvg } from './icons';
import type { LayerPattern } from '../patterns/index';
import { LAYER_SETTINGS_TYPES } from '../constants';

export const miniGraphs: LayerPattern = {
    id: 'MiniGraphs',
    key: 'well_debit_plot',
    title: 'Мини графики',
    icon: MiniGraphsSvg,
    settings: [
        {
            title: 'Жидкость (заливка)',
            key: 'liquidProductionBackroundColor',
            type: LAYER_SETTINGS_TYPES.COLOR,
            defaultValue: '#a8058079',
            level: 0,
        },
        {
            title: 'Нефть (заливка)',
            key: 'oilProductionBackroundColor',
            type: LAYER_SETTINGS_TYPES.COLOR,
            defaultValue: '#a8991f00',
            level: 0,
        },
        {
            title: 'Закачка воды (заливка)',
            key: 'waterInjectionBackroundColor',
            type: LAYER_SETTINGS_TYPES.COLOR,
            defaultValue: '#a800b300',
            level: 0,
        },
        {
            title: 'Обводненность (цвет линии)',
            key: 'wateringLineColor',
            type: LAYER_SETTINGS_TYPES.COLOR,
            defaultValue: '#a80038bf',
            level: 0,
        },
        {
            title: 'Обводненность (толщина линии)',
            key: 'wateringLineWidth',
            type: LAYER_SETTINGS_TYPES.FLOAT,
            defaultValue: 1,
            level: 0,
        },
        {
            title: 'Интервал',
            key: 'monthHalfCount',
            type: LAYER_SETTINGS_TYPES.INT,
            defaultValue: 6,
            level: 0,
        },
        {
            title: 'Ширина (Коэфф.)',
            key: 'horizontalScaleFactor',
            type: LAYER_SETTINGS_TYPES.FLOAT,
            defaultValue: 1,
            level: 0,
        },
        {
            title: 'Высота (коэфф.)',
            key: 'verticalScaleFactor',
            type: LAYER_SETTINGS_TYPES.FLOAT,
            defaultValue: 1,
            level: 0,
        },
        // {
        //     title: "id дебета",
        //     key: "debitVersion",
        //     type: LAYER_SETTINGS_TYPES.INT,
        //     defaultValue: true,
        //     level: 0,
        // },
    ],
};

// {
//     "liquidProductionBackroundColor": цвет
//     "oilProductionBackroundColor": цвет
//     "waterInjectionBackroundColor": цвет
//     "wateringLineColor": цвет
//     "wateringLineWidth": толщина линии (double)
//     "monthHalfCount": интервал / 2 (integer)
//     "horizontalScaleFactor": коэффициент по горизонтали (double)
//     "verticalScaleFactor": коэффициент по вертикали (double)
//     "debitVersion": id версии дебита (integer)
// }
